import { ChangeDetectorRef, ElementRef, OnDestroy, Pipe, Renderer2 } from '@angular/core';
import { TranslationService } from '@core/translation/translation.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslateUiPipe extends TranslatePipe implements OnDestroy {
  private string = null;

  private changeEditMode(value): void | boolean {
    if (!this._el.nativeElement.parentElement) {
      return false;
    }

    if (value) {
      this._renderer.addClass(this._el.nativeElement.parentElement, 'translated');
      const parentElement = this._el.nativeElement.parentElement;
      let theFirstChild = parentElement.firstChild;

      let newEditIcon = document.createElement('i');
      newEditIcon.classList.add('icon-Edit_ico');

      let newElement = document.createElement('div');
      newElement.classList.add('edit-trans-btn');

      newElement.insertBefore(newEditIcon, null);

      parentElement.insertBefore(newElement, theFirstChild);

      this._renderer.listen(newElement, 'click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const str = this.string;
        this._translationService.openTranslatableModal(str).subscribe();
      });
    } else {
      this._renderer.removeClass(this._el.nativeElement.parentElement, 'translated');
    }
  }

  transform(query: string, ...args): any {
    if (!this.string) this.string = query;
    return super.transform(query, ...args) || query;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  constructor(
    private _el: ElementRef,
    private _renderer: Renderer2,
    private _translationService: TranslationService,
    public _translateService: TranslateService,
    private _cds: ChangeDetectorRef
  ) {
    super(_translateService, _cds);

    if (this._translationService.editMode) {
      this.changeEditMode(this._translationService.editMode);
    }
  }
}
